import { FC } from 'react';
import { ListFilter } from 'lucide-react';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import DropdownButton from '@/shared/components/dropdowns/DropdownButton';
import type { DropdownButtonProps } from '@/shared/components/dropdowns/DropdownButton';
import SmallTag from '@/shared/components/tags/SmallTag';

interface FilterEntryButtonProps extends Omit<DropdownButtonProps, 'children'> {
    activeCount?: number;
}

const FilterEntryButton: FC<FilterEntryButtonProps> = ({
    activeCount = 0,
    size = 'small',
    type = 'dashed',
    ...props
}) => {
    const { token } = useAntDesignTheme();

    return (
        <DropdownButton {...props} size={size} type={type}>
            <span
                style={{
                    alignItems: 'center',
                    color: token.colorTextSecondary,
                    display: 'inline-flex',
                    gap: '0.25rem',
                }}
            >
                <ListFilter aria-hidden size='0.875rem' />
                <small>Filter</small>
                {activeCount > 0 ? <SmallTag message={activeCount} padding='0.1rem 0.35rem' /> : null}
            </span>
        </DropdownButton>
    );
};

export default FilterEntryButton;
